import { combineReducers } from 'redux';

import billing from './billing/reducer';
import deleteAccount from './deleteAccount/reducer';
import emailConfirmation from './emailConfirmation/reducer';
import login from './login/reducer';
import passwordReset from './passwordReset/reducer';
import requestPasswordReset from './requestPasswordReset/reducer';
import resendEmailConfirmation from './resendEmailConfirmation/reducer';
import signup from './signup/reducer';
import user from './user/reducer';
import upgradeSubscription from './upgradeSubscription/reducer';
import newsletterOptIn from './newsletterOptIn/reducer';

export default combineReducers({
  billing,
  deleteAccount,
  emailConfirmation,
  login,
  newsletterOptIn,
  passwordReset,
  resendEmailConfirmation,
  requestPasswordReset,
  signup,
  upgradeSubscription,
  user,
});
